<template>
  <div class="main-container">
    <div class="page-top-title">
      <p class="title">{{ reportName }}</p>
      <div class="page-top-right">
        <div class="item">
          结算日期：
          <span class="num">{{ settlementDate }}</span>
        </div>
        <div class="item settlement-status">
          结算状态：
          <div v-if="detailData.settlementStatus == 0" class="tag-settled">待结算</div>
          <div v-else class="tag-be">已结算</div>
        </div>
      </div>
    </div>
    <div class="statistics-container">
      <p>汇总数据</p>
      <div class="statistics-item">
        <div class="item">
          总人数：
          <span class="num">{{ statisticsObj.userNum || 0 }}</span>
        </div>
        <div class="item">
          保单数：
          <span class="num">{{ statisticsObj.policyNum || 0 }}</span>
        </div>
        <div class="item">
          保费：
          <span class="num">{{ statisticsObj.fee || 0 }}</span
          >元
        </div>
        <div class="item">
          费用合计：
          <span class="num">{{ statisticsObj.totalIncome || 0 }}</span
          >元
        </div>
        <div class="item">
          基本法收益合计
          <span class="label">
            <span class="tip-icon">?</span>：
            <div class="pop-tip">
              <span>以FYC和RYC为计算基础的基本法收益合计</span>
              <div class="arrow"></div>
            </div>
          </span>
          <span class="num">{{ statisticsObj.methodIncome || 0 }}</span
          >元
        </div>
        <div class="item">
          基本法外首期基础费用
          <span class="label">
            <span class="tip-icon">?</span>：
            <div class="pop-tip" style="width: 200px">
              <span>不计入基本法利益的首期基础费用</span>
              <div class="arrow"></div>
            </div>
          </span>
          <span class="num">{{ statisticsObj.baseFirstIncome || 0 }}</span
          >元
        </div>
        <div class="item">
          限时加费活动：
          <span class="num">{{ statisticsObj.platformActivityIncome || 0 }}</span
          >元
        </div>
        <div class="item">
          基本法外续期基础费用
          <span class="label">
            <span class="tip-icon">?</span>：
            <div class="pop-tip" style="width: 200px">
              <span>不计入基本法利益的续期基础费用</span>
              <div class="arrow"></div>
            </div>
          </span>
          <span class="num">{{ statisticsObj.baseRenewalIncome || 0 }}</span
          >元
        </div>
        <div class="item">
          首年后置费用：
          <span class="num">{{ statisticsObj.basePostfIncome || 0 }}</span
          >元
        </div>
        <div class="item" v-if="$units.isOkBao() || $units.isOkTX()">
          基本法扣款
          <span class="label">
            <span class="tip-icon">?</span>：
            <div class="pop-tip" style="width: 320px">
              <span>  因保单退保，出单时产生的已结算基本法利益需全额退回。</span>
            </div>
          </span>
          <span class="num">{{ statisticsObj.methodDeductIncome || 0 }}</span
          >元
        </div>
        <div class="item" v-if="!($units.isOkBao() || $units.isOkTX())">
          团队长首期管理费：
          <span class="num">{{ statisticsObj.baseFirstLeaderIncome || 0 }}</span
          >元
        </div>
        <div class="item" v-if="!($units.isOkBao() || $units.isOkTX())">
          团队长续期管理费：
          <span class="num">{{ statisticsObj.baseRenewalLeaderIncome || 0 }}</span
          >元
        </div>
        <div class="item" v-if="!($units.isOkBao() || $units.isOkTX())">
          团队长后置管理费：
          <span class="num">{{ statisticsObj.basePostfLeaderIncome || 0 }}</span
          >元
        </div>
      </div>
    </div>

    <Tabs v-model="tabVal" @on-click="clickTabs">
      <TabPane label="业务员明细" name="1"></TabPane>
      <TabPane label="按机构汇总" name="2"></TabPane>
    </Tabs>

    <div class="search-container" v-if="tabVal == '1'">
      <div class="search-box min">
        <div class="input-item">
          <span class="label">业务员</span>
          <Select placeholder="请选择" v-model="salesmanId" clearable filterable>
            <Option v-for="(item, i) in userList" :key="i" :value="item.id">
              <i class="dian" :class="{ red: item.workingState == 0, orange: item.isSus == 1 }"></i>
              {{ item.staffNo ? item.staffNo + '-' + item.name : item.name }}
            </Option>
          </Select>
        </div>
        <div class="btn-item btn-box">
          <Button type="primary" @click="searchAjax">查询</Button>
        </div>
      </div>
    </div>

    <loading :isShow="listLoading" />
    <div class="table-box">
      <Table ref="table" :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="userName_staffNo">
          <div class="name-status">
            <div v-if="row.userName" class="user-box">
              <i class="dian" :class="{ red: row.workingState == 0, orange: row.isSus == 1 }" v-if="row.userName"></i>
              <span class="user-name">{{ row.staffNo }}</span>
              <span v-if="row.staffNo">/</span>
              <span class="user-name">{{ row.userName }}</span>
            </div>
            <div v-else>-</div>
          </div>
        </template>

        <template slot-scope="{ row }" slot="recommendName_staffNo">
          <div class="name-status">
            <div v-if="row.recommendName" class="user-box">
              <i class="dian" :class="{ red: row.recommendWorkingState == 0, orange: row.recommendIsSus == 1 }" v-if="row.recommendName"></i>
              <span class="user-name">{{ row.recommendStaffNo }}</span>
              <span v-if="row.recommendStaffNo">/</span>
              <span class="user-name">{{ row.recommendName }}</span>
            </div>
            <div v-else>-</div>
          </div>
        </template>

        <template slot-scope="{ row }" slot="breedName_staffNo">
          <div class="name-status">
            <div v-if="row.breedName" class="user-box">
              <i class="dian" :class="{ red: row.breedWorkingState == 0, orange: row.breedIsSus == 1 }" v-if="row.breedName"></i>
              <span class="user-name">{{ row.breedStaffNo }}</span>
              <span v-if="row.breedStaffNo">/</span>
              <span class="user-name">{{ row.breedName }}</span>
            </div>
            <div v-else>-</div>
          </div>
        </template>

        <template slot-scope="{ row }" slot="groupLeaderName_staffNo">
          <div class="name-status">
            <div v-if="row.groupLeaderName" class="user-box">
              <i class="dian" :class="{ red: row.groupLeaderWorkingState == 0, orange: row.groupLeaderIsSus == 1 }" v-if="row.groupLeaderName"></i>
              <span class="user-name">{{ row.groupLeaderStaffNo }}</span>
              <span v-if="row.groupLeaderStaffNo">/</span>
              <span class="user-name">{{ row.groupLeaderName }}</span>
            </div>
            <div v-else>-</div>
          </div>
        </template>

        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="detailsPage(row)">详情</span>
        </template>
      </Table>
    </div>
    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />

    <div>
      <!-- 鑫路鸿 -->
      <Button
        type="primary"
        v-if="userInfo.merchantNo == '203258000000800' || userInfo.merchantNo == 'XINHONG001' || $units.isOkBao() || $units.isOkTX()"
        :disabled="detailData.settlementStatus != 0"
        class="btn"
        @click="calc"
        >计算基本法</Button
      >
      <Button class="btn" @click="back('/financialManage/basicLawSettlement')" v-if="step == 2">返回</Button>
      <Button class="btn" @click="backOperate" v-if="detailData.settlementStatus == 0">上一步</Button>
      <Button class="btn" @click="settledStep" v-if="detailData.settlementStatus == 1">上一步</Button>
      <Button class="btn" @click="exportReport">导出报表</Button>
      <Button type="primary" class="btn" @click="settlement" v-if="detailData.settlementStatus == 0">结算</Button>
      <Button type="primary" class="btn" v-else @click="resettlement">撤回结算</Button>
    </div>
  </div>
</template>

<script>
import { common, pageTool } from '@/api/mixins';
import filter from '@/api/filter';
export default {
  mixins: [common, pageTool],
  props: {
    backData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      reportId: null,
      settlementStatus: null,
      step: null,
      reportName: '',
      // commissionDate: '',
      settlementDate: '',
      statisticsObj: {},
      detailData: {},
      tabVal: '1',
      tableData: [],
      userList: [],
      salesmanId: '',
      total: 0,
      columns: [],
      columns1: [
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 200
        },
        {
          title: '团队',
          align: 'center',
          key: 'groupName',
          minWidth: 200
        },
        {
          title: '业务员',
          align: 'center',
          minWidth: 200,
          slot: 'userName_staffNo'
        },
        {
          title: '入职日期',
          align: 'center',
          key: 'entryTime',
          minWidth: 110,
          render(h, params) {
            let entryTime = params.row.entryTime;
            return <span>{filter.filterTime(entryTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '推荐人',
          align: 'center',
          key: 'recommendName',
          minWidth: 150,
          slot: 'recommendName_staffNo'
        },
        {
          title: '育成人',
          align: 'center',
          key: 'breedName',
          minWidth: 150,
          slot: 'breedName_staffNo'
        },
        {
          title: '上级主管',
          align: 'center',
          key: 'groupLeaderName',
          minWidth: 150,
          slot: 'groupLeaderName_staffNo'
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '费用合计',
          align: 'center',
          key: 'totalIncome',
          minWidth: 100
        },
        {
          title: '基本法收益合计',
          align: 'center',
          key: 'methodIncome',
          minWidth: 120
        },
        {
          title: '基本法外首期基础费用',
          align: 'center',
          key: 'baseFirstIncome',
          minWidth: 160
        },
        {
          title: '限时加费活动',
          align: 'center',
          key: 'platformActivityIncome',
          minWidth: 100
        },
        {
          title: '首年后置费用',
          align: 'center',
          key: 'basePostfIncome',
          minWidth: 100
        },
        {
          title: '基本法外续期基础费用',
          align: 'center',
          key: 'baseRenewalIncome',
          minWidth: 160
        },
        {
          title: '团队长首期管理费',
          align: 'center',
          key: 'baseFirstLeaderIncome',
          minWidth: 140
        },
        {
          title: '团队长续期管理费',
          align: 'center',
          key: 'baseRenewalLeaderIncome',
          minWidth: 130
        },
        {
          title: '团队长后置管理费',
          align: 'center',
          key: 'basePostfLeaderIncome',
          minWidth: 130
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 80,
          fixed: 'right'
        }
      ],
      columns2: [
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 200
        },
        {
          title: '人数',
          align: 'center',
          key: 'userNum',
          minWidth: 100
        },
        {
          title: '保单数',
          align: 'center',
          key: 'policyNum',
          minWidth: 100
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '费用合计',
          align: 'center',
          key: 'totalIncome',
          minWidth: 100
        },
        {
          title: '基本法收益合计',
          align: 'center',
          key: 'methodIncome',
          minWidth: 120
        },
        {
          title: '基本法外首期基础费用',
          align: 'center',
          key: 'baseFirstIncome',
          minWidth: 160
        },
        {
          title: '限时加费活动',
          align: 'center',
          key: 'platformActivityIncome',
          minWidth: 100
        },
        {
          title: '基本法外续期基础费用',
          align: 'center',
          key: 'baseRenewalIncome',
          minWidth: 160
        },
        {
          title: '首年后置费用',
          align: 'center',
          key: 'basePostfIncome',
          minWidth: 120
        },
        {
          title: '团队长首期管理费',
          align: 'center',
          key: 'baseFirstLeaderIncome',
          minWidth: 140
        },
        {
          title: '团队长续期管理费',
          align: 'center',
          key: 'baseRenewalLeaderIncome',
          minWidth: 130
        },
        {
          title: '团队长后置管理费',
          align: 'center',
          key: 'basePostfLeaderIncome',
          minWidth: 130
        }
      ]
    };
  },
  created() {
    const { reportId, settlementDate, reportName, step } = this.$route.query;
    this.reportId = reportId;
    this.reportName = reportName;
    this.settlementDate = settlementDate;
    this.step = step;
    this.getUserList();
  },
  activated() {
    if (this.reportId) {
      this.clickTabs(this.tabVal);
    }
  },
  methods: {
    calc() {
      this.$notice.inquiry('是否重新计算?').then(() => {
        this.listLoading = true;
        this.$http({
          url: '/buz/userSettlementDetail/baseMethod/calculate',
          type: 'POST',
          data: {
            reportId: this.reportId
          }
        })
          .then(res => {
            this.getList();
            this.getDetailData();
            this.getStatisticsData();
            this.listLoading = false;
            this.$notice.success('操作成功');
          })
          .catch(e => {
            this.listLoading = false;
          });
      });
    },
    setData() {
      const { reportId, settlementDate, reportName } = this.backData;
      this.reportId = reportId;
      this.reportName = reportName;
      this.settlementDate = settlementDate;
      this.clickTabs(this.tabVal);
      this.getUserList();
    },

    searchAjax() {
      this.pageNum = 1;
      this.getList();
      this.getStatisticsData();
    },

    clickTabs(value) {
      let columns = [];
      if (value == 1) {
        columns = JSON.parse(JSON.stringify(this.columns1));
      } else {
        columns = JSON.parse(JSON.stringify(this.columns2));
      }
      if (this.$units.isOkBao() || this.$units.isOkTX()) {
        let idx = columns.findIndex(i => i.key == 'baseFirstLeaderIncome');
        // debugger
        columns.splice(idx, 3);
        idx = columns.findIndex(i => i.key == 'recommendName');
        if (idx != -1) {
          columns.splice(idx, 0, {
            title: '结算职级',
            align: 'center',
            key: 'rankName',
            render(h, params) {
              let entryTime = params.row.rankName || '-';
              return <span>{entryTime}</span>;
            },
            minWidth: 130
          });
        }
        idx = columns.findIndex(i => i.key == 'groupLeaderName');
        if (idx != -1) {
          columns.splice(++idx, 0, {
            title: '件数',
            align: 'center',
            key: 'policyNum',
            minWidth: 130
          });
        }

        idx = columns.findIndex(i => i.key == 'methodDeductIncome');
        if (idx == -1) {
          columns.push({
            title: '基本法扣款',
            align: 'center',
            key: 'methodDeductIncome',
            minWidth: 130
          });
        }
      }
      this.columns = columns;
      this.pageNum = 1;
      this.getList();
      this.getStatisticsData();
      this.getDetailData();
    },

    // 获取当前机构业务员
    getUserList() {
      this.$http({
        url: '/buz/userBase/getByOrgIds',
        type: 'POST',
        data: {
          orgaList: []
        }
      }).then(res => {
        this.userList = res.data;
      });
    },

    // 获取详情
    getDetailData() {
      this.$http({
        url: '/buz/userSettlementReport/read/detail',
        type: 'GET',
        data: {
          id: this.reportId
        }
      }).then(res => {
        this.detailData = res.data;
      });
    },

    // 统计
    getStatisticsData() {
      this.$http({
        url: '/buz/userSettlementDetail/statistics',
        type: 'POST',
        data: {
          reportId: this.reportId,
          userId: this.salesmanId
        }
      }).then(res => {
        if (res.data) {
          this.statisticsObj = res.data;
        }
      });
    },

    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/userSettlementDetail/read/page',
        type: 'POST',
        data: {
          reportId: this.reportId,
          groupType: this.tabVal,
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          userId: this.salesmanId
        }
      })
        .then(res => {
          this.tableData = res.data;
          this.total = res.total;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    //  详情
    detailsPage(row) {
      this.openPageTabTags('/financialManage/basicLawSettlement/detail', {
        reportId: this.reportId,
        tabVal: this.tabVal,
        orgId: row.orgId,
        userId: row.userId,
        detailId: row.id,
        settlementDate: this.settlementDate,
        userName: row.staffNo + '/' + row.userName,
        groupName: row.groupName,
        orgName: row.orgName,
        entryTime: filter.filterTime(row.entryTime, 'YYYY-MM-DD')
      });
    },

    // 上一步
    backOperate() {
      if (!this.$units.pointAction('offline_81_1_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$http({
        url: '/buz/userSettlementDetail/rollback',
        type: 'POST',
        data: {
          reportId: this.reportId
        }
      }).then(res => {
        this.$emit('backPage', { reportId: this.reportId, isAdd: 0, settled: false });
      });
    },

    // 已结算上一步
    settledStep() {
      this.$emit('settledStep', { reportId: this.reportId, isAdd: 0, settled: true });
    },

    // 导出
    exportReport() {
      if (!this.$units.pointAction('offline_81_1_3')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$units.downloadFile('/buz/userSettlementDetail/export', { reportId: this.reportId }, 'POST');
    },

    // 结算
    settlement() {
      if (!this.$units.pointAction('offline_81_1_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      let arr = ['203258000000800', 'XINHONG001'];
      let txt = '您确定结算吗?';
      if (arr.includes(this.userInfo.merchantNo) && this.detailData.isCalculate != '1') {
        txt = '尚未点击计算按钮生成基本法相关利益，是否继续结算？';
      }
      this.$notice.inquiry(txt).then(() => {
        this.$http({
          url: '/buz/userSettlementReport/settlement',
          type: 'POST',
          data: {
            id: this.reportId
          }
        }).then(res => {
          this.getList();
          this.getDetailData();
          this.$notice.success('结算成功');
        });
      });
    },

    // 撤回结算
    resettlement() {
      if (!this.$units.pointAction('offline_81_1_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      if (this.detailData.releaseStatus == '1') {
        this.$http({
          url: '/buz/userSettlementReport/resettlement',
          type: 'POST',
          data: {
            id: this.reportId
          }
        }).then(res => {
          this.getDetailData();
          this.$notice.success('撤回成功');
        });
      } else {
        this.$notice.inquiry('您确定撤回结算吗?').then(() => {
          this.$http({
            url: '/buz/userSettlementReport/resettlement',
            type: 'POST',
            data: {
              id: this.reportId
            }
          }).then(res => {
            this.getList();
            this.getDetailData();
            this.$notice.success('撤回成功');
          });
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-top-title {
  font-size: 15px;
  display: flex;
  .title {
    font-size: 16px;
    color: #3c464f;
    font-weight: bold;
  }
  .page-top-right {
    display: flex;
    align-items: center;
    margin-left: auto;
    .item {
      color: #515c6f;
      font-size: 14px;
      margin-left: 20px;
    }
    .settlement-status {
      margin-top: 1px;
      margin-left: 20px;
      display: flex;
      .tag-settled {
        width: 55px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 2px;
        font-size: 13px;
        color: #e3461f;
        border: 1px solid #ffc1b2;
        background: #fff5f2;
      }
      .tag-be {
        width: 55px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 4px;
        font-size: 13px;
        color: #35bf3f;
        border: 1px solid #abeaae;
        background: #f6fcf4;
      }
    }
  }
}
.statistics-container {
  margin-top: 20px;
  display: flex;
  p {
    white-space: nowrap;
  }
  .statistics-item {
    margin-left: 20px;
    display: flex;
    flex-wrap: wrap;
    color: #333;

    .item {
      font-weight: bold;
      white-space: nowrap;
      margin-bottom: 10px;
      width: 300px;
      .num {
        color: #ff7134;
      }

      .label {
        position: relative;

        .tip-icon {
          margin-right: 2px;
          width: 15px;
          height: 15px;
          border-radius: 15px;
          background: transparent;
          border: 1px solid #9c9c9c;
          color: #a8a6a6;
          display: inline-block;
          text-align: center;
          line-height: 14px;
          font-size: 14px;
          cursor: pointer;
          top: 50%;
        }

        .tip-icon:hover + .pop-tip {
          opacity: 0.9;
          z-index: 9999;
          display: block;
        }

        .pop-tip {
          position: absolute;
          width: 250px;
          top: -42px;
          display: flex;
          align-items: center;
          text-align: left;
          left: 50%;
          margin-left: -90px;
          padding: 6px 10px;
          display: flex;
          flex-direction: column;
          background-color: #444444;
          display: none;
          border-radius: 4px;

          span {
            font-size: 12px;
            font-weight: 500;
            color: #fff;
          }

          .arrow {
            position: absolute;
            width: 12px;
            height: 12px;
            background-color: #444444;
            opacity: 0.9;
            bottom: -4px;
            left: 74px;
            transform: rotateZ(135deg);
          }
        }
      }
    }
  }
}
.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: top;
  transform: translateY(7px);
  &.red {
    background: #e3461f;
  }
  &.orange {
    background: #ff9900 !important;
  }
}
.name-status {
  align-items: center;
  /deep/ .user-box {
    font-size: 12px;
    .dian {
      display: inline-block;
      flex-shrink: 0;
      width: 5px;
      height: 5px;
      background: #35bf3f;
      border-radius: 50%;
      margin-right: 4px;
      &.red {
        background: #e3461f;
      }
      &.orange {
        background: #ff9900 !important;
      }
    }
    &.text {
      color: #515c6f;
    }
    .user-name {
      font-size: 13px;
      &.dashed {
        border-bottom: 1px dashed #236dff;
      }
      &.line {
        border-bottom: 1px solid #236dff;
      }
    }
    i {
      color: #bababa;
      font-size: 13px;
    }
    .iconduichang {
      margin-left: 4px;
    }
    &.no-token {
      color: #515c6f;
      .user-name {
        cursor: auto;
      }
    }
  }
}
</style>
